
export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get in <strong>Touch</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Have questions or need support? We're here to help you with any inquiries about our products and services
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
              <i className="ri-map-pin-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">Address</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              RIO DULCE 855<br />
              Carcarañá, S2138AOK<br />
              Argentina
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
              <i className="ri-mail-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">Email</h3>
            <p className="text-sm text-gray-600 leading-relaxed break-all">
              help@aselcosrl.com
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
              <i className="ri-phone-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-3">Number</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              +1 4472272391
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
